import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, money, fmtTime } from "@/lib/api";
import { StatusBadge } from "@/components/Badges";
import PageHeader, { Empty } from "@/components/PageHeader";
import { t } from "@/lib/i18n";

export default function MyBids() {
  const [bids, setBids] = useState(null);
  const load = useCallback(() => api.get("/bids/mine").then((r) => setBids(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const act = async (path, msg) => {
    try { await api.post(path); toast.success(msg); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div>
      <PageHeader kicker={t("Transporter console")} title={t("My Bids")}>
        <Link to="/marketplace" className="hf-btn-primary" data-testid="btn-browse-loads">{t("Browse loads")}</Link>
      </PageHeader>
      {bids?.length === 0 && <Empty title={t("No bids yet")} testId="my-bids-empty">{t("Find a load on the board and accept the rate or counter-bid.")}</Empty>}
      <div className="space-y-3">
        {bids?.map((b, i) => (
          <div key={b.id} className="hf-card p-5 hf-rise flex flex-col md:flex-row md:items-center gap-4 justify-between" style={{ animationDelay: `${i * 40}ms` }} data-testid={`my-bid-${b.id}`}>
            <div className="min-w-0">
              <p className="font-mono text-xs text-slate-500">{b.shipper_code} · {fmtTime(b.created_at)}</p>
              <Link to={`/loads/${b.load_id}`} className="font-display font-bold text-lg hover:text-amber-700 break-words">{b.load_summary}</Link>
              <p className="font-mono text-sm mt-1">{money(b.price_per_mt, b.currency || "USD")}{t("/mt")} {b.is_counter && <span className="text-xs text-amber-700">{t("· counter-bid")}</span>}</p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <StatusBadge status={b.status} testId={`my-bid-status-${b.id}`} />
              {b.status === "shipper_accepted" && (
                <>
                  <button onClick={() => act(`/bids/${b.id}/confirm`, t("Connection confirmed!"))} className="hf-btn-primary h-9" data-testid={`btn-confirm-bid-${b.id}`}>{t("Confirm & connect")}</button>
                  <button onClick={() => act(`/bids/${b.id}/decline`, t("Bid withdrawn"))} className="hf-btn-ghost h-9">{t("Withdraw")}</button>
                </>
              )}
              {b.status === "confirmed" && <Link to={`/connections/${b.id}`} className="hf-btn-dark h-9" data-testid={`btn-view-connection-${b.id}`}>{t("Open connection")}</Link>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
